import { render, staticRenderFns } from "./AlertEventConfiguration.vue?vue&type=template&id=18ea1860&"
import script from "./AlertEventConfiguration.vue?vue&type=script&lang=ts&"
export * from "./AlertEventConfiguration.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports